export default __webpack_public_path__ + "static/819-ad79edca26d12acc0912cf38cd8f17a9.gif";